<template>
  <div>
    <div v-if="showWarning" class="text-center warning white--text">
      <p>
        <v-icon color="white">link_off</v-icon>
        {{ $t('shooting.header.notSync') }}
      </p>
    </div>

    <div class="d-flex align-center pr-16">
      <BackButton class="flex-shrink-0" />
      <div class="flex-grow-1 text-center">
        <span>{{ $t('shooting.title') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton.vue'

export default {
  name: 'ShootingStandardHeader',
  components: {
    BackButton
  },
  props: {
    shootingType: {
      type: String,
      default: 'STANDARD'
    },
    shootingInformations: {
      type: Object,
      default: () => ({
        videoName: '',
        registration: '',
        created: '',
        productType: null
      })
    }
  },
  computed: {
    displayDate() {
      return this.shootingType !== 'VIDEO'
    },
    isVirtualOwner() {
      const [ownerType] = this.$route.params.ownerId.split('_')
      return ownerType === 'VIRTUAL'
    },
    isVirtualProduct() {
      return this.shootingInformations.productType === 'VIRTUAL'
    },
    isRemarketing() {
      return ['STANDARD', 'VIDEO'].includes(this.shootingType)
    },
    showWarning() {
      return !this.isVirtualOwner && this.isRemarketing && this.isVirtualProduct
    }
  }
}
</script>
